export const M2_UNIT_REVIEW = {
  id: "m2-review",
  title: "Module 2 Review",
  topic: "Full Revision",
  iconType: "star", // Estrella para indicar examen/revisión
  grammarImage: "/m2-review-grammar.jpg", // Sube esta imagen a public
  grammarText: "Repaso general de todo el Módulo 2: Lugares, Casa, Comida, Cantidades y Posesión.",
  sets: [
    {
      id: "m2-final-review-s1",
      title: "Set 1: And/But + Adjectives + House Vocab",
      questions: [
        { type: "mc", q: "Library ___ restaurant. (and)", options: ["and", "but"], a: "and" },
        { type: "mc", q: "No hotel, ___ a café. (but)", options: ["but", "and"], a: "but" },
        { type: "blank", q: "The town is ___ and noisy. (busy)", options: ["busy"], a: "busy" },
        { type: "order", q: "Ordena: beautiful old buildings", words: ["beautiful", "old", "buildings"], a: "beautiful old buildings" },
        { type: "mc", q: "Cook here: ___", options: ["kitchen", "bedroom"], a: "kitchen" },
        { type: "blank", q: "Sleep here: ___ (bedroom).", options: ["bedroom"], a: "bedroom" },
        { type: "mc", q: "'There's a hotel and store and café.' Fix commas?", options: ["True - needs commas", "False"], a: "True - needs commas" },
        { type: "order", q: "Ordena: living room couch", words: ["living", "room", "couch"], a: "living room couch" },
        { type: "blank", q: "US: refrigerator = UK: ___ (fridge).", options: ["fridge"], a: "fridge" },
        { type: "mc", q: "Small town, big city → ___", options: ["but", "and"], a: "but" },
        { type: "blank", q: "No garage, ___ yard. (but)", options: ["but"], a: "but" },
        { type: "order", q: "Ordena: quiet countryside, busy city", words: ["quiet", "countryside,", "busy", "city"], a: "quiet countryside, busy city" }
      ]
    },
    {
      id: "m2-final-review-s2",
      title: "Set 2: Because + Have/Has + Food Vocab",
      questions: [
        { type: "mc", q: "I work in kitchen ___ I'm a chef.", options: ["because", "and"], a: "because" },
        { type: "mc", q: "She lives on farm ___ she's a farmer.", options: ["because", "but"], a: "because" },
        { type: "blank", q: "I ___ a fridge. (have)", options: ["have"], a: "have" },
        { type: "order", q: "Ordena: She has a loaf of bread.", words: ["She", "has", "a", "loaf", "of", "bread."], a: "She has a loaf of bread." },
        { type: "mc", q: "Chicken + beef = ___", options: ["meat", "fish"], a: "meat" },
        { type: "blank", q: "Apple + banana = ___ (fruit).", options: ["fruit"], a: "fruit" },
        { type: "mc", "q": "Why chef? ___ kitchen job.", options: ["Because", "And"], a: "Because" },
        { type: "blank", q: "Do you ___ any milk? (have)", options: ["have"], a: "have" },
        { type: "order", q: "Ordena: jar of jam", words: ["jar", "of", "jam"], a: "jar of jam" },
        { type: "mc", "q": "Countable: apples. Uncountable: ___", options: ["sugar", "eggs"], a: "sugar" },
        { type: "blank", q: "No sugar, ___ honey. (but)", options: ["but"], a: "but" },
        { type: "mc", "q": "Does she have a carton milk? Yes, she ___", options: ["does", "has"], a: "does" }
      ]
    },
    {
      id: "m2-final-review-s3",
      title: "Set 3: Some/Any + Questions + Measurements",
      questions: [
        { type: "mc", q: "I have ___ apples.", options: ["some", "any"], a: "some" },
        { type: "mc", q: "Do you have ___ sugar?", options: ["any", "some"], a: "any" },
        { type: "blank", q: "___ you have a toaster? (Do)", options: ["Do"], a: "Do" },
        { type: "order", q: "Ordena: Does she have any plates?", words: ["Does", "she", "have", "any", "plates?"], a: "Does she have any plates?" },
        { type: "mc", "q": "Flour: 500 ___", options: ["grams", "liters"], a: "grams" },
        { type: "blank", q: "Milk: 2 ___ (liters).", options: ["liters"], a: "liters" },
        { type: "mc", "q": "Recipe: 1 ___ salt. (teaspoon)", options: ["teaspoon", "tablespoon"], a: "teaspoon" },
        { type: "blank", q: "No, I don't have ___ rice. (any)", options: ["any"], a: "any" },
        { type: "order", q: "Ordena: 2 cups flour", words: ["2", "cups", "flour"], a: "2 cups flour" },
        { type: "mc", "q": "Does the kitchen have a sink? Yes, it ___", options: ["does", "has"], a: "does" },
        // Convertido a MC
        { type: "mc", q: "___ rice + ___ water. (some/2 liters)", options: ["some / 2 liters", "any / 2 liter"], a: "some / 2 liters" },
        { type: "mc", q: "Shopping: bag of rice, loaf of bread. True?", options: ["True", "False"], a: "True" }
      ]
    },
    {
      id: "m2-final-review-s4",
      title: "Set 4: Present Simple + Frequency + Time",
      questions: [
        { type: "mc", q: "I ___ up at 7am.", options: ["get", "gets"], a: "get" },
        { type: "mc", "q": "She ___ breakfast.", options: ["eats", "eat"], a: "eats" },
        { type: "blank", q: "We ___ TV in the evening. (watch)", options: ["watch"], a: "watch" },
        { type: "order", q: "Ordena: He always brushes his teeth.", words: ["He", "always", "brushes", "his", "teeth."], a: "He always brushes his teeth." },
        { type: "mc", q: "___ Monday I go shopping.", options: ["On", "In"], a: "On" },
        { type: "blank", q: "___ 8am I start work. (At)", options: ["At"], a: "At" },
        { type: "mc", "q": "She ___ eats candy. (never)", options: ["never", "always"], a: "never" },
        { type: "blank", q: "Do you ___ coffee? (drink)", options: ["drink"], a: "drink" },
        { type: "order", q: "Ordena: On weekends we visit family.", words: ["On", "weekends", "we", "visit", "family."], a: "On weekends we visit family." },
        { type: "mc", "q": "I don't ___ meat.", options: ["eat", "eats"], a: "eat" },
        { type: "blank", q: "She ___ forgets her keys. (rarely)", options: ["rarely"], a: "rarely" },
        { type: "mc", "q": "Does he work on Saturdays? No, he ___", options: ["doesn't", "don't"], a: "doesn't" }
      ]
    },
    {
      id: "m2-final-review-s5",
      title: "Set 5: Full Mixed Challenge",
      questions: [
        { type: "mc", q: "Riverside: 3 bedrooms, ___ bathrooms.", options: ["2", "4"], a: "2" },
        { type: "blank", q: "Lake View: big kitchen in ___, no garage. (basement)", options: ["basement"], a: "basement" },
        { type: "order", q: "Ordena: Stone Hill has bathtub and shower.", words: ["Stone", "Hill", "has", "bathtub", "and", "shower."], a: "Stone Hill has bathtub and shower." },
        { type: "mc", q: "Recipe: 500g flour + 2 ___ milk.", options: ["liters", "grams"], a: "liters" },
        // Convertido a MC
        { type: "mc", q: "I have ___ apples. Do you need ___ apples? (some/any)", options: ["some / any", "any / some"], a: "some / any" },
        { type: "mc", q: "US: couch / UK: ___", options: ["sofa", "chair"], a: "sofa" },
        { type: "order", q: "Ordena: Do you have a kitchen sink?", words: ["Do", "you", "have", "a", "kitchen", "sink?"], a: "Do you have a kitchen sink?" },
        // Convertido a MC
        { type: "mc", q: "She ___ up at 7am ___ has breakfast. (gets/and)", options: ["gets / and", "get / but"], a: "gets / and" },
        { type: "mc", q: "Why chef? ___ works in kitchen.", options: ["Because", "And"], a: "Because" },
        // Convertido a MC
        { type: "mc", q: "2 ___ bread + 1 ___ milk. (loaves/liter)", options: ["loaves / liter", "loaf / liters"], a: "loaves / liter" },
        { type: "order", q: "Ultimate: I live in busy town because I work in office.", words: ["I", "live", "in", "busy", "town", "because", "I", "work", "in", "office."], a: "I live in busy town because I work in office." },
        { type: "mc", q: "All correct: some/any, have questions, house vocab, measurements. True?", options: ["True", "False"], a: "True" }
      ]
    }
  ]
};
